import * as React from 'react';

import './Welcome.scss';

export interface IWelcomeStateProps {
  message: string;
}

const Welcome: React.FC<IWelcomeStateProps> = ({ message }) => {
  return (
    <div className='flexible-height-col welcome'>
      <div className='p-3'>
        <div
          className='pt-1'
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
      </div>
    </div>
  );
};

export default Welcome;
